import { takeLatest, call, put, all } from 'redux-saga/effects';

// SERVICES
import { ApiResponse, postApi } from 'services/_api';
import { CHANNEL, PATH_PROCON } from 'services/_path';

// TYPES
import { ReducerAction } from 'store/modules/types';
import { RespostaResolvidaRequest, Types } from './types';

// ACTIONS
import { respostaResolvidaSuccess, respostaResolvidaFailure } from './actions';

function* respostaResolvidaRequest(request: ReducerAction) {
	const { payload }: { payload: RespostaResolvidaRequest } = request;

	const response: ApiResponse = yield call(
		postApi,
		PATH_PROCON,
		`atendimentos-cip/${CHANNEL}/cips/respostas-resolvidas`,
		payload,
	);

	if (response.status === 200) {
		yield put(respostaResolvidaSuccess(response));
	} else {
		yield put(respostaResolvidaFailure(response));
	}
}

export default all([
	takeLatest(Types.RESPOSTA_RESOLVIDA_REQUEST, respostaResolvidaRequest),
]);
